function encString(_str: string /*, _key: number */): string {
    return btoa(_str);
}

function decString(_str: string, _key: number): string {
    return atob(_str);
}

const key: number = 90847356917;

export function encryptPayload(data: object): string {
    const json = JSON.stringify(data);
    const cipherText = encString(json /*, key*/).toString();

    return JSON.stringify({ enc: cipherText });
}

export function decryptPayload(cipherText: string | object): any {
    let bytes = null;
    let json = null;
    let data = null;

    try {
        if(typeof cipherText === "string") {
            bytes = decString(JSON.parse(cipherText).enc, key);
        } else {
            bytes = decString((cipherText as {enc: string}).enc, key);
        }
        json = bytes.toString();
        data = JSON.parse(json);
    } catch (e) {
        console.warn(e);
        return null;
    }

    return data;
}
